const styles = theme => ({
  "@keyframes barAnimation": {
    from: {
      width: "0%"
    },
    to: {
      width: "25%"
    }
  },
  backgroundImageContainer: {
    position: "absolute",
    top: "0",
    right: "0",
    bottom: "0",
    left: "0",
    zIndex: 0,
    backgroundSize: "cover"
  },
  backgroundImageGradient: {
    background: `linear-gradient(180deg, ${theme.palette.secondary.main} 0%, ${
      theme.palette.primary.main
    } 100%)`,
    position: "absolute",
    top: "0",
    right: "0",
    bottom: "0",
    left: "0",
    opacity: 0.9
  },
  setupContent: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 1,
    padding: "50px 60px"
  },
  screenIdentifier: {
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    borderWidth: 12,
    borderStyle: "solid",
    opacity: 0,
    zIndex: 10,
    visibility: "hidden",
    transition: theme.transitions.create(["opacity", "visibility"], {
      easing: theme.transitions.easing.sharp,
      duration: ".5s"
    })
  },
  showScreenIdentifier: {
    opacity: 1,
    visibility: "visible"
  },
  top: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start"
  },
  cast: {
    display: "flex",
    alignItems: "baseline"
  },
  castIcon: {
    width: 100,
    display: "inline",
    marginRight: theme.spacing.unit * 1.5
  },
  setupContentTitle: {
    display: "inline",
    fontFamily: "Oswald",
    fontWeight: 200,
    textTransform: "uppercase",
    lineHeight: "1.2em",
    fontSize: 50,
    color: theme.palette.common.white
  },
  setupContentInstructions: {
    display: "block",
    textAlign: "left",
    color: theme.palette.common.white
  },
  instructionsBold: {
    display: "inline",
    padding: "0 4px",
    color: "#fff",
    fontWeight: 600
  },
  bottom: {
    position: "absolute",
    bottom: 0,
    left: 0,
    zIndex: 1,
    padding: "30px 60px",
    width: "100%",
    maxWidth: 600
  },
  nameWrapper: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-end"
  },
  screenName: {
    fontFamily: "Oswald",
    fontWeight: 200,
    textTransform: "uppercase",
    fontSize: 50,
    color: theme.palette.common.white,
    textAlign: "left"
  },
  bidrLogo: {
    height: 45,
    marginBottom: 10
  },
  colorBars: {
    display: "flex",
    height: 12
  },
  bar: {
    height: 12,
    width: "0%",
    backgroundColor: "#fff",
    animationName: "barAnimation",
    animationTimingFunction: "ease-out",
    animationFillMode: "forwards",
    animationDuration: "0.5s"
  },
  screenId: {
    fontFamily: "Oswald",
    fontSize: 28,
    fontWeight: 200,
    paddingTop: 3,
    textAlign: "left",
    color: theme.palette.common.white
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/pages/Event/styles.js